import React from "react";

import {
  Button,
  Form,
  FormGroup,
  Label,
  Col,
  Container,
  Row
} from "reactstrap";

import SelectListComponent from "../utils/selectList";
import DateSelector from "../utils/dateSelector";

const ReportsPanel = ({
  travelRoutes,
  selectedTravelRoute,
  onTravelRouteValueChange,
  onSearch,
  startDateChange,
  endDateChange
}) => {
  return (
    <Form onSubmit={e => e.preventDefault()}>
      <Container>
        <Row>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Start Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="startDate"
                onValueChange={startDateChange}
              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>End Date</Label>
              <DateSelector
                maxDate={new Date()}
                todayDate={new Date().toString()}
                name="endDate"
                onValueChange={endDateChange}
              />
            </FormGroup>
          </Col>
          <Col xs="6" sm="3">
            <FormGroup className="mb-4">
              <Label>Travel Route</Label>
              <SelectListComponent
                data={travelRoutes}
                valueKey="value"
                textField="label"
                selectValue={selectedTravelRoute}
                onValueChange={onTravelRouteValueChange}
              />
            </FormGroup>
          </Col>

          <Col xs="6" sm="1">
            <label>&nbsp;</label>
            <Button className="btn-avi-primary" onClick={() => onSearch()}>
              Search
            </Button>
          </Col>
        </Row>
      </Container>
    </Form>
  );
};

export default ReportsPanel;



// WEBPACK FOOTER //
// ./src/views/reports/reports-panel.js